import { C41TableProps } from './C41Table';
import {
  TableBody,
  TableCell,
  TableCellProps,
  TableContainerProps,
  TableHead,
  TableHeader,
  TableHeaderProps,
  TableRow,
  TableRowProps,
} from '@ahc-digital/component-library';
import { TableCellFields } from './C41Table.types';
import { DATA_ROW_TEMPLATEID, HEADER_ROW_TEMPLATEID } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetTableModel(props?: C41TableProps) {
  type t = TableContainerProps;
  const { renderRichText, renderText } = useConditionalRendering();
  const { HeadlineTag, ContentAlignment, TableStyling, PinFirstColumn, CellAlignment } =
    props?.params || {};
  const { Headline, SupportCopy } = props?.fields?.table?.fields || {};

  const headlineTag = getDroplink<t['headlineTag']>(HeadlineTag, 'p');
  const contentAlignment = getDroplink<t['contentAlignment']>(ContentAlignment, 'left');
  const tableStyle = getDroplink<t['tableStyle']>(TableStyling, 'standard');
  const shouldPinFirstColumn = !!PinFirstColumn;
  const cellAlignment = getDroplink<t['cellAlignment']>(CellAlignment, 'center');

  const headerRowItem = props?.fields?.table?.children?.find(
    (child) => child?.templateId === HEADER_ROW_TEMPLATEID
  );

  const headerRowCellItems = (headerRowItem?.children || []) as {
    fields: TableCellFields;
  }[];

  const dataRowItems = props?.fields?.table?.children?.filter(
    (child) => child?.templateId === DATA_ROW_TEMPLATEID
  );

  return {
    headline: renderText(Headline) as TableContainerProps['headline'],
    supportCopy: renderRichText(SupportCopy) as TableContainerProps['supportCopy'],
    headlineTag,
    contentAlignment,
    tableStyle,
    cellAlignment,
    shouldPinFirstColumn,
    children: (
      <>
        {
          <TableHeader
            cellAlignment={
              headerRowItem?.fields?.CellAlignment?.fields?.Value
                ?.value as TableHeaderProps['cellAlignment']
            }
          >
            <TableRow
              cellAlignment={
                headerRowItem?.fields?.CellAlignment?.fields?.Value
                  ?.value as TableRowProps['cellAlignment']
              }
            >
              {headerRowCellItems.map((headerRow, index) => (
                <TableHead key={index}>{renderRichText(headerRow?.fields?.TableData)}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
        }
        <TableBody>
          {dataRowItems?.map((dataRowItem, index) => {
            const dataRowCellItems = (dataRowItem?.children || []) as {
              fields: TableCellFields;
            }[];
            return (
              <TableRow
                cellAlignment={
                  dataRowItem?.fields?.CellAlignment?.fields?.Value
                    ?.value as TableCellProps['cellAlignment']
                }
                key={index}
              >
                {dataRowCellItems.map((dataRowCell, index) => {
                  return (
                    <TableCell
                      cellAlignment={
                        dataRowCell?.fields?.CellAlignment?.fields?.Value
                          ?.value as TableCellProps['cellAlignment']
                      }
                      icon={
                        dataRowCell?.fields?.Icon?.fields?.Value?.value as TableCellProps['icon']
                      }
                      key={index}
                    >
                      {renderRichText(dataRowCell?.fields?.TableData)}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </>
    ),
  };
}
